import { Observable } from "rxjs"
import { ObservableFromFetch } from "../ObservableFromFetch"
import BusinessType from "./BusinessType"

export default function BusinessTypesGetObservable(link?: string): Observable<BusinessType[]> {
  const requestBody: string = JSON.stringify(link ? { Link: link } : { })

  return ObservableFromFetch<BusinessType[]>("FFOrderClinicEnrollment/GetBusinessType", requestBody)
}
